import {
  SHOW_SEARCH_AI_PROMPT,
  HIDE_SEARCH_AI_PROMPT,
  SHOW_SEARCH_RESULTS,
  SET_SEARCH_INPUT_VALUE,
  SET_SEARCH_AI_STOPS,
  SEARCH_LOADING,
  SearchAIActionTypes,
} from "./actions";

const initialState = {
  showSearchAIPrompt: false,
  showResults: false,
  searchInputValue: "",
  searchLoading: false,
  searchAIStops: [],
};

const SearchAIReducer = (state = initialState, action: SearchAIActionTypes) => {
  switch (action.type) {
    case SHOW_SEARCH_AI_PROMPT:
      return { ...state, showSearchAIPrompt: true };
    case HIDE_SEARCH_AI_PROMPT:
      return { ...state, showSearchAIPrompt: false, showResults: false };
    case SHOW_SEARCH_RESULTS:
      return { ...state, showResults: true };
    case SET_SEARCH_INPUT_VALUE:
      return { ...state, searchInputValue: action.payload };
    case SEARCH_LOADING:
      return { ...state, searchLoading: action.payload };
    case SET_SEARCH_AI_STOPS:
      return { ...state, searchAIStops: action.payload };
    default:
      return state;
  }
};

export default SearchAIReducer;
